import React,{ElementType, HTMLAttributes} from "react";


type TagProps = (
    | React.ComponentProps<"button">
    | React.ComponentProps<"a"> & { href: string }
)

interface DTagComponentProps {
    as?: ElementType;
    children: any;
}

const DTag: React.FC<DTagComponentProps & TagProps> = ({as: Tag = "a", children, ...rest}) => {
    return (
        <Tag {...rest}>{children}</Tag>
    );
}

export default DTag;